import e from "react";
import { FloatingPortal as o } from "@floating-ui/react";
const l = _ref => {
  let {
    children: t,
    enabled: r
  } = _ref;
  return r ? e.createElement(o, {
    preserveTabOrder: !0
  }, t) : e.createElement(e.Fragment, null, t);
};
export { l as ConditionalFloatingPortal };